// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__MRqPh.styles_ocean-50__OSuWI {
  color: #e6f2ff;
}

.styles_color__MRqPh.styles_ocean-100__Zeh8x {
  color: #e6f2ff;
}

.styles_color__MRqPh.styles_ocean-200__4\\+vqM {
  color: #b3daff;
}

.styles_color__MRqPh.styles_ocean-300__ZCHGF {
  color: #7abfff;
}

.styles_color__MRqPh.styles_ocean-400__teRZN {
  color: #2392fb;
}

.styles_color__MRqPh.styles_ocean-500__zwj6R {
  color: #0074e0;
}

.styles_color__MRqPh.styles_ocean-600__vpxvD {
  color: #043571;
}

.styles_color__MRqPh.styles_space-50__ddxQ- {
  color: #f0f0f0;
}

.styles_color__MRqPh.styles_space-100__AHppo {
  color: #e3e3e3;
}

.styles_color__MRqPh.styles_space-200__NeyR\\+ {
  color: #bfbfbf;
}

.styles_color__MRqPh.styles_space-300__Zwwf3 {
  color: gray;
}

.styles_color__MRqPh.styles_space-400__rmaNq {
  color: #616161;
}

.styles_color__MRqPh.styles_space-500__6bTBB {
  color: #283439;
}

.styles_color__MRqPh.styles_gray-50__H9JkQ {
  color: #eff3f6;
}

.styles_color__MRqPh.styles_gray-100__GosJZ {
  color: #e6ecef;
}

.styles_color__MRqPh.styles_gray-200__R3W3e {
  color: #cfd8de;
}

.styles_color__MRqPh.styles_gray-300__\\+dTSY {
  color: #a8b9c2;
}

.styles_color__MRqPh.styles_gray-400__H1-Fx {
  color: #7e98a5;
}

.styles_color__MRqPh.styles_gray-500__yGD\\+S {
  color: #738f9c;
}

.styles_color__MRqPh.styles_green-50__GkaaB {
  color: #e3fdf6;
}

.styles_color__MRqPh.styles_green-100__G3H44 {
  color: #c5f6ea;
}

.styles_color__MRqPh.styles_green-200__1MYS\\+ {
  color: #69ddc2;
}

.styles_color__MRqPh.styles_green-300__SWBA5 {
  color: #45bfa3;
}

.styles_color__MRqPh.styles_green-400__-jtlU {
  color: #1cab8a;
}

.styles_color__MRqPh.styles_green-500__7LQnL {
  color: #128268;
}

.styles_color__MRqPh.styles_red-50__u\\+h\\+1 {
  color: #fff0f3;
}

.styles_color__MRqPh.styles_red-100__nUBf9 {
  color: #f9d2db;
}

.styles_color__MRqPh.styles_red-200__27osL {
  color: #f8b4c4;
}

.styles_color__MRqPh.styles_red-300__v35k0 {
  color: #e85e81;
}

.styles_color__MRqPh.styles_red-400__AazGf {
  color: #e23661;
}

.styles_color__MRqPh.styles_red-500__NItFl {
  color: #b82348;
}

.styles_color__MRqPh.styles_yellow-50__SWJC4 {
  color: #fffae6;
}

.styles_color__MRqPh.styles_yellow-100__JT02k {
  color: #fff0b3;
}

.styles_color__MRqPh.styles_yellow-200__LL-8m {
  color: #ffe380;
}

.styles_color__MRqPh.styles_yellow-300__s45ZH {
  color: #ffcf57;
}

.styles_color__MRqPh.styles_yellow-400__RUpGT {
  color: #ffc60a;
}

.styles_color__MRqPh.styles_yellow-500__wlZ70 {
  color: #ffb700;
}

.styles_color__MRqPh.styles_orange-50__veMLZ {
  color: #fff2eb;
}

.styles_color__MRqPh.styles_orange-100__Q-xCR {
  color: #ffe4d6;
}

.styles_color__MRqPh.styles_orange-200__m-Twx {
  color: #ffc69e;
}

.styles_color__MRqPh.styles_orange-300__5EDHB {
  color: #ffa047;
}

.styles_color__MRqPh.styles_orange-400__uDRTn {
  color: #ff7b42;
}

.styles_color__MRqPh.styles_orange-500__ke41N {
  color: #ee4920;
}

.styles_color__MRqPh.styles_turquoise-50__uJ86w {
  color: transparent;
}

.styles_color__MRqPh.styles_turquoise-100__5Purd {
  color: #e6fcff;
}

.styles_color__MRqPh.styles_turquoise-200__PxwO9 {
  color: #b3f5ff;
}

.styles_color__MRqPh.styles_turquoise-300__RbZXz {
  color: #78e2f2;
}

.styles_color__MRqPh.styles_turquoise-400__VOHZX {
  color: #00c7e6;
}

.styles_color__MRqPh.styles_turquoise-500__Tkssb {
  color: transparent;
}

.styles_color__MRqPh.styles_turquoise-600__MN5jv {
  color: transparent;
}

.styles_color__MRqPh.styles_violet-50__l-Q8T {
  color: #eae6ff;
}

.styles_color__MRqPh.styles_violet-100__DRVVa {
  color: #d9d1ff;
}

.styles_color__MRqPh.styles_violet-200__5uhEB {
  color: #bfb3ff;
}

.styles_color__MRqPh.styles_violet-300__Rjres {
  color: #9d90ea;
}

.styles_color__MRqPh.styles_violet-400__a0R5K {
  color: #8678d9;
}

.styles_color__MRqPh.styles_violet-500__EgoGx {
  color: #6f5ccc;
}

.styles_color__MRqPh.styles_snow-50__jtBoL {
  color: white;
}

.styles_color__MRqPh.styles_snow-100__dVSQw {
  color: #f7f7f7;
}

.styles_color__MRqPh.styles_snow-200__QSo0n {
  color: #f0efef;
}

.styles_color__MRqPh.styles_snow-300__hl8v4 {
  color: #e6e6e6;
}

.styles_color__MRqPh.styles_snow-400__GRW3d {
  color: #e1e0e0;
}

.styles_color__MRqPh.styles_snow-500__i99xJ {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__s5JEp.styles_ocean__j7nEv {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__s5JEp.styles_ocean-light__9yc3f {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__s5JEp.styles_green__w5bLa {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__s5JEp.styles_green-light__SpSI\\+ {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__s5JEp.styles_red__fpz\\+F {
  background-color: #e23661;
  color: white;
}

.styles_background-color__s5JEp.styles_red-light__TMj7K {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__s5JEp.styles_orange__EIMqM {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__s5JEp.styles_orange-light__CyuUS {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__s5JEp.styles_space__r0uY0 {
  background-color: #616161;
  color: white;
}

.styles_background-color__s5JEp.styles_space-light__VILed {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__s5JEp.styles_gray-light__T-TWS {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__s5JEp.styles_violet__Vr1OQ {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__s5JEp.styles_violet-light__1s2W3 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__s5JEp.styles_yellow__625Cj {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__s5JEp.styles_yellow-light__2wACu {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
/* TODO: The font-sizes used here are based on "em", but they should be based on "rem"
 * to make all icons with the same "size" prop, the same size.
 * The size shouldn't be based on the font-size of container. Also, we can't use width with FA icons.
 */
.styles_root__yrtYX {
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  text-align: left;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  vertical-align: middle;
  align-items: center;
  display: inline-flex;
  justify-content: center;
}
.styles_root__yrtYX::-moz-focus-inner {
  border-style: none;
}
.styles_root__yrtYX.styles_xs__OyRrv {
  height: 18px;
  max-height: 18px;
  max-width: 18px;
  width: 18px;
}
.styles_root__yrtYX.styles_xs__OyRrv > svg {
  font-size: 0.7857142857rem;
  width: 14px;
}
.styles_root__yrtYX.styles_sm__yrAOj {
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  width: 20px;
}
.styles_root__yrtYX.styles_sm__yrAOj > svg {
  font-size: 0.9285714286rem;
  width: 16px;
}
.styles_root__yrtYX.styles_md__wjygc {
  height: 24px;
  max-height: 24px;
  max-width: 24px;
  width: 24px;
}
.styles_root__yrtYX.styles_md__wjygc > svg {
  font-size: 1.1428571429rem;
  width: 20px;
}
.styles_root__yrtYX.styles_lg__ua21F {
  height: 30px;
  max-height: 30px;
  max-width: 30px;
  width: 30px;
}
.styles_root__yrtYX.styles_lg__ua21F > svg {
  font-size: 1.5rem;
  width: 26px;
}

.styles_error__MSyQj {
  color: #e23661;
}

.styles_warning__F\\+sbK {
  color: #ffc60a;
}

.styles_success__i9A7a {
  color: #1cab8a;
}

.styles_primary__d1eWU {
  color: #2392fb;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/icon/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_misc.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADfA;;;EAAA;AAKA;EEmBI,wBAAA;UAAA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,sBAAA;EF9BA,mBAAA;EACA,oBAAA;EACA,uBAAA;AAuVJ;AEzTI;EACI,kBAAA;AF2TR;AAxVI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AA0VR;AAxVQ;EACI,0BAAA;EACA,WAAA;AA0VZ;AAtVI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAwVR;AAtVQ;EACI,0BAAA;EACA,WAAA;AAwVZ;AApVI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAsVR;AApVQ;EACI,0BAAA;EACA,WAAA;AAsVZ;AAlVI;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAoVR;AAlVQ;EACI,iBAAA;EACA,WAAA;AAoVZ;;AA/UA;EACI,cAAA;AAkVJ;;AA/UA;EACI,cAAA;AAkVJ;;AA/UA;EACI,cAAA;AAkVJ;;AA/UA;EACI,cAAA;AAkVJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use '~$app-web/ui-kit/styles/theme';\n\n/* TODO: The font-sizes used here are based on \"em\", but they should be based on \"rem\"\n * to make all icons with the same \"size\" prop, the same size.\n * The size shouldn't be based on the font-size of container. Also, we can't use width with FA icons.\n */\n\n.root {\n    @include theme.reset-button();\n\n    align-items: center;\n    display: inline-flex;\n    justify-content: center;\n\n    &.xs {\n        height: 18px;\n        max-height: 18px;\n        max-width: 18px;\n        width: 18px;\n\n        > svg {\n            font-size: theme.px2rem(11px);\n            width: 14px;\n        }\n    }\n\n    &.sm {\n        height: 20px;\n        max-height: 20px;\n        max-width: 20px;\n        width: 20px;\n\n        > svg {\n            font-size: theme.px2rem(13px);\n            width: 16px;\n        }\n    }\n\n    &.md {\n        height: 24px;\n        max-height: 24px;\n        max-width: 24px;\n        width: 24px;\n\n        > svg {\n            font-size: theme.px2rem(16px);\n            width: 20px;\n        }\n    }\n\n    &.lg {\n        height: 30px;\n        max-height: 30px;\n        max-width: 30px;\n        width: 30px;\n\n        > svg {\n            font-size: theme.px2rem(21px);\n            width: 26px;\n        }\n    }\n}\n\n.error {\n    color: theme.color(red-400);\n}\n\n.warning {\n    color: theme.color(yellow-400);\n}\n\n.success {\n    color: theme.color(green-400);\n}\n\n.primary {\n    color: theme.color(ocean-400);\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:math';\n@use 'sass:meta';\n@use './colors';\n\n@function if-important($important) {\n    @return #{if($important, '!important', '')};\n}\n\n@function strip-unit($value) {\n    @if meta.type-of($value) == 'number' and not math.is-unitless($value) {\n        @return math.div($value, ($value * 0 + 1));\n    }\n\n    @return $value;\n}\n\n@function is-map($variable) {\n    @return meta.type-of($variable) == 'map';\n}\n\n@function is-string($variable) {\n    @return meta.type-of($variable) == 'string';\n}\n\n// Reset the button to behave like div\n@mixin reset-button() {\n    appearance: none;\n    background-color: transparent;\n    border: 0;\n    border-radius: 0;\n    color: inherit;\n    cursor: pointer;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    position: relative;\n    -webkit-tap-highlight-color: transparent;\n    text-align: left;\n    text-decoration: none;\n    user-select: none;\n    vertical-align: middle;\n\n    &::-moz-focus-inner {\n        border-style: none;\n    }\n}\n\n@mixin scrollbar() {\n    // The new standard syntax (Currently only supported in Firefox)\n    scrollbar-color: colors.color(gray-200) colors.color(snow-50);\n    scrollbar-width: thin;\n\n    // For Chrome, Edge, Safari, and Opera\n    ::-webkit-scrollbar {\n        height: 7px;\n        width: 5px;\n    }\n\n    ::-webkit-scrollbar-thumb {\n        background: colors.color(gray-200);\n        border-radius: 5px;\n    }\n\n    ::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    ::-webkit-scrollbar-thumb:hover {\n        background: colors.color(gray-200);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__MRqPh`,
	"ocean-50": `styles_ocean-50__OSuWI`,
	"ocean-100": `styles_ocean-100__Zeh8x`,
	"ocean-200": `styles_ocean-200__4+vqM`,
	"ocean-300": `styles_ocean-300__ZCHGF`,
	"ocean-400": `styles_ocean-400__teRZN`,
	"ocean-500": `styles_ocean-500__zwj6R`,
	"ocean-600": `styles_ocean-600__vpxvD`,
	"space-50": `styles_space-50__ddxQ-`,
	"space-100": `styles_space-100__AHppo`,
	"space-200": `styles_space-200__NeyR+`,
	"space-300": `styles_space-300__Zwwf3`,
	"space-400": `styles_space-400__rmaNq`,
	"space-500": `styles_space-500__6bTBB`,
	"gray-50": `styles_gray-50__H9JkQ`,
	"gray-100": `styles_gray-100__GosJZ`,
	"gray-200": `styles_gray-200__R3W3e`,
	"gray-300": `styles_gray-300__+dTSY`,
	"gray-400": `styles_gray-400__H1-Fx`,
	"gray-500": `styles_gray-500__yGD+S`,
	"green-50": `styles_green-50__GkaaB`,
	"green-100": `styles_green-100__G3H44`,
	"green-200": `styles_green-200__1MYS+`,
	"green-300": `styles_green-300__SWBA5`,
	"green-400": `styles_green-400__-jtlU`,
	"green-500": `styles_green-500__7LQnL`,
	"red-50": `styles_red-50__u+h+1`,
	"red-100": `styles_red-100__nUBf9`,
	"red-200": `styles_red-200__27osL`,
	"red-300": `styles_red-300__v35k0`,
	"red-400": `styles_red-400__AazGf`,
	"red-500": `styles_red-500__NItFl`,
	"yellow-50": `styles_yellow-50__SWJC4`,
	"yellow-100": `styles_yellow-100__JT02k`,
	"yellow-200": `styles_yellow-200__LL-8m`,
	"yellow-300": `styles_yellow-300__s45ZH`,
	"yellow-400": `styles_yellow-400__RUpGT`,
	"yellow-500": `styles_yellow-500__wlZ70`,
	"orange-50": `styles_orange-50__veMLZ`,
	"orange-100": `styles_orange-100__Q-xCR`,
	"orange-200": `styles_orange-200__m-Twx`,
	"orange-300": `styles_orange-300__5EDHB`,
	"orange-400": `styles_orange-400__uDRTn`,
	"orange-500": `styles_orange-500__ke41N`,
	"turquoise-50": `styles_turquoise-50__uJ86w`,
	"turquoise-100": `styles_turquoise-100__5Purd`,
	"turquoise-200": `styles_turquoise-200__PxwO9`,
	"turquoise-300": `styles_turquoise-300__RbZXz`,
	"turquoise-400": `styles_turquoise-400__VOHZX`,
	"turquoise-500": `styles_turquoise-500__Tkssb`,
	"turquoise-600": `styles_turquoise-600__MN5jv`,
	"violet-50": `styles_violet-50__l-Q8T`,
	"violet-100": `styles_violet-100__DRVVa`,
	"violet-200": `styles_violet-200__5uhEB`,
	"violet-300": `styles_violet-300__Rjres`,
	"violet-400": `styles_violet-400__a0R5K`,
	"violet-500": `styles_violet-500__EgoGx`,
	"snow-50": `styles_snow-50__jtBoL`,
	"snow-100": `styles_snow-100__dVSQw`,
	"snow-200": `styles_snow-200__QSo0n`,
	"snow-300": `styles_snow-300__hl8v4`,
	"snow-400": `styles_snow-400__GRW3d`,
	"snow-500": `styles_snow-500__i99xJ`,
	"background-color": `styles_background-color__s5JEp`,
	"ocean": `styles_ocean__j7nEv`,
	"ocean-light": `styles_ocean-light__9yc3f`,
	"green": `styles_green__w5bLa`,
	"green-light": `styles_green-light__SpSI+`,
	"red": `styles_red__fpz+F`,
	"red-light": `styles_red-light__TMj7K`,
	"orange": `styles_orange__EIMqM`,
	"orange-light": `styles_orange-light__CyuUS`,
	"space": `styles_space__r0uY0`,
	"space-light": `styles_space-light__VILed`,
	"gray-light": `styles_gray-light__T-TWS`,
	"violet": `styles_violet__Vr1OQ`,
	"violet-light": `styles_violet-light__1s2W3`,
	"yellow": `styles_yellow__625Cj`,
	"yellow-light": `styles_yellow-light__2wACu`,
	"root": `styles_root__yrtYX`,
	"xs": `styles_xs__OyRrv`,
	"sm": `styles_sm__yrAOj`,
	"md": `styles_md__wjygc`,
	"lg": `styles_lg__ua21F`,
	"error": `styles_error__MSyQj`,
	"warning": `styles_warning__F+sbK`,
	"success": `styles_success__i9A7a`,
	"primary": `styles_primary__d1eWU`
};
export default ___CSS_LOADER_EXPORT___;
